/* eslint-disable camelcase */

import PropTypes from "prop-types";
/* eslint-disable no-irregular-whitespace */
import React from "react";
import SkeletonProductCard from "theme/components/skeletons/ProductCard";
import loadable from "@loadable/component";
import productProp from "core-web/utils/proptypes/product";
import transformAlgoliaProduct from "core-web/utils/dataTransformers/transformAlgoliaProduct";
import transformStormProduct from "core-web/utils/dataTransformers/transformStormProduct";
import useAboveBreakpoint from "core-web/hooks/useAboveBreakpoint";
import useBelowBreakpoint from "core-web/hooks/useBelowBreakpoint";

// const Content = loadable(() => import("theme/components/products/ProductGrid/Content"));
const ProductCard = loadable(() => import("theme/components/products/ProductCard"), {
    fallback: <SkeletonProductCard />,
});

const ProductMap = ({ displayCampaignAreas, isDistinct, gridContent, products, isFirstModule, isLandingPage }) => {
    const isMobile = useBelowBreakpoint("tabletLg");
    const isTablet = useAboveBreakpoint("tabletLg");
    const isDesktop = useAboveBreakpoint("tabletLg");

    return (
        <>
            {products.map((product, index) => {
                const transformedProduct = product.objectID
                    ? transformAlgoliaProduct(product, null, isDistinct)
                    : transformStormProduct(product);

                return (
                    <ProductCard
                        key={`${transformedProduct.partNo}_${transformedProduct.url}`}
                        {...transformedProduct}
                        // order={index}
                        // position={index}
                        loading={
                            (isDesktop && index < 4) || (isTablet && index < 3) || (isMobile && index < 2)
                                ? "eager"
                                : "lazy"
                        }
                    />
                );
            })}
            {/* {displayCampaignAreas &&
                (gridContent || []).map((content, index) => <Content key={index} orderIndex={index} block={content} />)} */}
        </>
    );
};

ProductMap.propTypes = {
    // displayCampaignAreas: PropTypes.bool,
    gridContent: PropTypes.arrayOf(PropTypes.shape({})),
    isDistinct: PropTypes.bool,
    isFirstModule: PropTypes.bool,
    isLandingPage: PropTypes.bool,
    products: PropTypes.arrayOf(productProp).isRequired,
};

ProductMap.defaultProps = {
    // displayCampaignAreas: false,
    gridContent: [],
    isDistinct: true,
    isFirstModule: false,
    isLandingPage: false,
};

export default ProductMap;
